// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@storybook/builder-webpack5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove z-index from "show code" button container */
/* https://github.com/microsoft/fluentui/issues/22773 */
.docs-story > div:nth-child(2) {
  z-index: auto;
}

#storybook-docs .docblock-code-toggle,
.docs-story .with-code-sandbox-button {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',
    sans-serif;
  min-width: 91px;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 150% !important;
  color: #201f1e !important;
  text-align: center !important;
  justify-content: center !important;
  letter-spacing: -0.01em !important;
  background: #f8f8f8 !important;
  border: none !important;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25) !important; */
  border-radius: 5px 5px 0px 0px !important;
}

.docs-story .with-code-sandbox-button {
  margin-right: 32px;
}

/* Reduce font size of CodeSandbox and Show Code button when zoomed or small window width*/
/* https://github.com/microsoft/fluentui/issues/22764 */

@media screen and (max-width: 380px) {
  #storybook-docs .docblock-code-toggle,
  .docs-story .with-code-sandbox-button {
    font-size: 10px !important;
  }
}

/* Make storybook codesandbox export button match Figma design */
.docs-story .with-code-sandbox-button {
  right: 105px !important;
}

.docs-story .with-code-sandbox-button:focus {
  outline: none;
  box-shadow: #1ea7fd 0 -3px 0 0 inset;
}
`, "",{"version":3,"sources":["webpack://./../../packages/react-components/react-storybook-addon-export-to-sandbox/src/styles.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA;;EAEE;cACY;EACZ,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,8BAA8B;EAC9B,uBAAuB;EACvB,4DAA4D;EAC5D,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0FAA0F;AAC1F,uDAAuD;;AAEvD;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,gEAAgE;AAChE;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC","sourcesContent":["/* Remove z-index from \"show code\" button container */\n/* https://github.com/microsoft/fluentui/issues/22773 */\n.docs-story > div:nth-child(2) {\n  z-index: auto;\n}\n\n#storybook-docs .docblock-code-toggle,\n.docs-story .with-code-sandbox-button {\n  font-family: 'Segoe UI', 'Segoe UI Web (West European)', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue',\n    sans-serif;\n  min-width: 91px;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 150% !important;\n  color: #201f1e !important;\n  text-align: center !important;\n  justify-content: center !important;\n  letter-spacing: -0.01em !important;\n  background: #f8f8f8 !important;\n  border: none !important;\n  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25) !important; */\n  border-radius: 5px 5px 0px 0px !important;\n}\n\n.docs-story .with-code-sandbox-button {\n  margin-right: 32px;\n}\n\n/* Reduce font size of CodeSandbox and Show Code button when zoomed or small window width*/\n/* https://github.com/microsoft/fluentui/issues/22764 */\n\n@media screen and (max-width: 380px) {\n  #storybook-docs .docblock-code-toggle,\n  .docs-story .with-code-sandbox-button {\n    font-size: 10px !important;\n  }\n}\n\n/* Make storybook codesandbox export button match Figma design */\n.docs-story .with-code-sandbox-button {\n  right: 105px !important;\n}\n\n.docs-story .with-code-sandbox-button:focus {\n  outline: none;\n  box-shadow: #1ea7fd 0 -3px 0 0 inset;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
